module.exports = __webpack_public_path__ + "static/media/iconSave.874675a1.svg";